export const maltaVallettaGozoProgram = {
  programKey: 'malta-miedzy-valletta-a-gozo',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Malta - Między Vallettą a Gozo',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Malta:',
  stickySubtitle: 'Między Vallettą a Gozo',

  pageUrl:
    'https://coolturystki.pl/wycieczki/malta-miedzy-valletta-a-gozo',

  /* Dane marketingowe będzie można uzupełnić podczas pracy nad katalogiem. */
  catalog: {
    image:
      'https://coolturystki.pl/lib/wyfaqa/malta-gozo-port-i-zabudowa-mt1ozwid.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/malta-gozo-port-i-zabudowa-mt1ozwid.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Malta'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-08-21',
  },

  /* Każdy termin jest osobnym wyjazdem w Vakanzie. */
  tripIds: [11, 12],

  /*
   * Nie dodajemy priceNote ani priceNotePrice. Dzięki temu pod kartą
   * automatycznie pojawi się pierwsza transza wyliczona z aktualnej ceny.
   */
  termDetails: {
    '11': {
      pilotId: 'marta',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Kraków - Balice',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Krakowa',
          description:
            'Grupa leci z lotniska Balice w Krakowie (KRK) na Maltę (MLA). Lot bezpośredni w obie strony.',
        },
        hotel: {
          title: 'Hotel 3★ w St. Julian’s',
          description:
            'Nocleg w St. Julian’s, w pokojach 2-osobowych ze śniadaniami.',
        },
      },
    },

    '12': {
      pilotId: 'marta',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa leci z lotniska Chopina w Warszawie (WAW) na Maltę (MLA). Lot bezpośredni w obie strony.',
        },
        hotel: {
          title: 'Hotel 3★ w St. Julian’s',
          description:
            'Nocleg w St. Julian’s, w pokojach 2-osobowych ze śniadaniami.',
        },
      },
    },
  },
}
